import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { updateUserPasswordFormObject, updateErrors, initFormObjects } from '@store/slice/usersSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { post } from '@util/xhrAPI'
import Div from '@ui/layout/Div'
import Form from '@ui/elements/Form'
import userPasswordFormFields, { userUpdatePasswordUrl } from '@form/userPasswordFormFields'
import useStoreUpdate from "@hook/useStoreUpdate"
import useToggle from "@hook/useToggle"
import useFormData from "@hook/useFormData"

const UpdateUserPassword = () => {
  const [isLoading, toggleLoading] = useToggle(false)
  const { userPasswordFormObject, errors } = useSelector(state => state.users)
  const dispatch = useDispatch()
  const [t] = useTranslation('user')
  const renderFormData = useFormData()
  const [updateFormObject] = useStoreUpdate(dispatch, updateUserPasswordFormObject, userPasswordFormObject)

  const saveForm = () => {
    toggleLoading()
    post(userUpdatePasswordUrl, renderFormData(userPasswordFormObject), response => {
      const { code, errors } = response
      if (code === 200) {
        dispatch(updateErrors([]))
        dispatch(initFormObjects({}))
        dispatch(updateNotification({ type: 'is-success', message: t('alerts.password_updated') }))
      } else {
        dispatch(updateErrors(errors))
      }
      toggleLoading()
    })
  }

  return (
    <Div cssClass='update-password loggued-user'>
      <h2 className='scene-title'>{t('titles.user_reset_password')}</h2>
      <Form cssClass='user-password-form columns is-multiline'>
        {userPasswordFormFields(userPasswordFormObject, errors, isLoading, updateFormObject, saveForm, t)}
      </Form>
    </Div>
  )
}

export default UpdateUserPassword